const ar = {
  welcomeMessage: 'مرحباً بك ',
  home: 'الرئيسية',
  payment: 'المدفوعات',
  success: 'نجاح الدفع',
  tryagain: 'يرجي المحاولة مرة اخري',
  dashboard: 'لوحة المعلومات',
  theBill: 'الفاتورة',
  choosePaymentMethod: 'إختر طريقة للدفع',
  creditCard: 'البطاقة الإئتمانية',
  totalAmout: 'المجموع',
  riyal: 'ريال',

  addNewCard: 'أضف بطاقة جديدة',
  firstName: 'الإسم الأول',
  lastName: 'الإسم الأخير',
  idNumber: 'رقم الهوية',
  cvv: 'رمز الأمان',
  cardNumber: 'رقم البطاقة',
  expiryDate: 'تاريخ انتهاء الصلاحية',
  registeredNameOnCard: 'الاسم المسجل على البطاقة',
  requestStatus: 'حالة الطلب',
  awaitingPaymentMessage: 'تم إنشاء فاتورة سداد بنجاح وحالة طلبك الآن بإنتظار السداد',
  awaitingPayment: 'بإنتظار السداد',
  underProcessingMessage: 'سيتم تقديم الطلب مباشرة بعد التأكيد',
  underProcessing: 'بإنتظار بوابة الدفع لتأكيد العملية',
  failed: 'فشل عملية الدفع',
  failedMessage: 'لم تتم عملية الدفع بنجاح، يمكنك إعادة المحاولة مرة أخرى',
  failedMessageContactSupport: 'أو مراجعة الدعم الفني بالكود التالي',
  cancelled: 'بإنتظار الدفع',
  cancelledMessage: 'لم تتم عملية الدفع حتى الآن، يمكنك إعادة المحاولة مرة أخرى',
  retrycheckout: 'إعادة المحاولة',
  sadadBillExpired: 'انتهاء صلاحية فاتورة سداد',
  sadadBillExpiredMessage: 'تم إلغاء رقم الفاتورة لإنتهاء فترة السداد',
  sadadReferenceNumber: 'رقم فاتورة سداد',
  shouldPaidBefore: 'يجب ان يتم الدفع قبل ',
  copiedSuccessfully: 'تم النسخ بنجاح',
  backToTechSupport: 'مراجعة الدعم الفني',
  backToHome: 'العودة للرئيسية',
  requestsList: 'قائمة الطلبات',
  paymentInfo: 'بيانات الدفع',
  successMessage: 'تم قبول الطلب بنجاح',
  successMessageDescription: 'تم الدفع بنجاح و تقديم طلبك رقم {requestNumber}',
  requestPreview: 'معاينة الطلب',
  referenceNumber: 'الرقم المرجعي',
  requestNumberIs: 'طلب رقم: {requestNumber}',
  unAvailable: 'غير متوفر',
  individual: 'فرد',
  establishment: 'منشأة',
  hijriSuffix: 'هـ',
  gregorianSuffix: 'م',
  morningTimeFullSuffix: 'صباحاً',
  eveningTimeFullSuffix: 'مساءاً',
  requestDetails: 'تفاصيل الخدمة',

  alRajhiCardErrors: {
    'Please enter valid CardHolder First Name': 'الرجاء إدخال الاسم الأول لحامل البطاقة',
    'Please enter valid CardHolder Last Name': 'الرجاء إدخال اسم العائلة لحامل البطاقة',
    'Please enter valid Card Number': 'الرجاء إدخال رقم بطاقة صالح',
    'Please enter valid Card Expiry Month': 'الرجاء إدخال تاريخ إنتهاء صلاحية البطاقة',
    'Please enter valid Card Expiry Year': 'الرجاء إدخال تاريخ إنتهاء صلاحية البطاقة',
    'Please enter valid CVV': 'الرجاء إدخال الرقم السري للبطاقة',
  },
  serverErrors: {
    SERVER_ERROR: 'حدث خطأ في النظام',
    USER_NOT_FOUND: 'المستخدم غير موجود الرجاء المحاولة مرة أخرى',
  },
};

export default ar;
